import { useTranslation } from 'react-i18next';

import { ContentLayout } from '../../layout/ContentLayout';
import PageMetatags from '../../layout/PageMetatags';
import FormCard from './FormCard';

const FormsOverviewPage = () => {
  const { t } = useTranslation();

  return (
    <ContentLayout>
      <PageMetatags title={t('pages:config_forms.table.header_form')} />
      <FormCard />
    </ContentLayout>
  );
};

export default FormsOverviewPage;
